/* SA Search overlay — used by sections/sa-search.liquid */
(function () {
  'use strict';
  if (window.__sasMount) { window.__sasMount(); return; }

  var RECENT_KEY = 'saSearchRecent';
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);
  var S = { root: null, open: false, pushed: false, pendingNav: null, ctrl: null, cache: {}, timer: null, wordI: 0, active: -1, uid: 0, lastFocus: null, quiet: false, words: [] };

  var ICON = {
    search: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    clock: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    fill: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 17 7 7"/><path d="M7 15V7h8"/></svg>',
    grid: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>'
  };

  function $(sel, el) { return (el || S.root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || S.root).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    n = Number(n);
    if (!isFinite(n)) return '';
    return '₹' + Math.round(n).toLocaleString('en-IN');
  }
  function imgUrl(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function searchUrl(q) { return S.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product'; }
  function q() { return S.input ? S.input.value.trim() : ''; }
  function vis(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function live(t) { var l = $('[data-sas-live]'); if (l) l.textContent = t; }

  function hl(text, query) {
    var words = String(query).toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; })
      .map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    if (!words.length) return esc(text);
    var re = new RegExp('(' + words.join('|') + ')', 'ig');
    return String(text).split(re).map(function (part, i) { return i % 2 ? '<mark>' + esc(part) + '</mark>' : esc(part); }).join('');
  }
  function suggHtml(text, query) {
    var t = String(text), lq = String(query).toLowerCase();
    if (lq && t.toLowerCase().indexOf(lq) === 0) return esc(t.slice(0, lq.length)) + '<b>' + esc(t.slice(lq.length)) + '</b>';
    return hl(t, query);
  }

  /* Recent searches */
  function getRecent() {
    try {
      var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return typeof x === 'string' && x; }).slice(0, 6) : [];
    } catch (e) { return []; }
  }
  function addRecent(t) {
    t = String(t || '').trim();
    if (t.length < 2) return;
    var a = getRecent().filter(function (x) { return x.toLowerCase() !== t.toLowerCase(); });
    a.unshift(t.slice(0, 60));
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 6))); } catch (e) {}
  }
  function renderRecent() {
    var wrap = $('[data-sas-recent-wrap]'), box = $('[data-sas-recent]');
    if (!wrap || !box) return;
    var a = getRecent();
    wrap.hidden = !a.length;
    box.innerHTML = a.map(function (t) {
      return '<a class="sas-chip sas-chip--recent sas-opt" href="' + esc(searchUrl(t)) + '" data-term="' + esc(t) + '">' + ICON.clock + '<span>' + esc(t) + '</span></a>';
    }).join('');
  }

  function formatMoney() {
    $$('[data-sas-money]').forEach(function (el) {
      var v = parseFloat(el.getAttribute('data-sas-money'));
      if (isFinite(v)) el.textContent = money(v / 100);
    });
  }

  /* Views */
  function showView(name) {
    $$('[data-sas-view]').forEach(function (v) { v.hidden = v.getAttribute('data-sas-view') !== name; });
    setActive(-1);
  }
  function currentView() {
    var v = $$('[data-sas-view]').filter(function (x) { return !x.hidden; });
    return v[0] || null;
  }
  function opts() {
    var v = currentView();
    return v ? $$('.sas-opt', v).filter(vis) : [];
  }
  function setActive(i, list) {
    list = list || opts();
    $$('.sas-opt.is-active').forEach(function (el) { el.classList.remove('is-active'); el.removeAttribute('aria-selected'); });
    S.active = i;
    if (i >= 0 && list[i]) {
      var el = list[i];
      el.classList.add('is-active');
      el.setAttribute('aria-selected', 'true');
      if (!el.id) el.id = 'sas-opt-' + (++S.uid);
      S.input.setAttribute('aria-activedescendant', el.id);
      try { el.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    } else if (S.input) {
      S.input.removeAttribute('aria-activedescendant');
    }
  }

  function cardHtml(p, query) {
    var price = parseFloat(p.price || p.price_min);
    var cmp = parseFloat(p.compare_at_price_max || p.compare_at_price_min || 0);
    var off = cmp > price ? Math.floor((cmp - price) * 100 / cmp) : 0;
    var fi = p.featured_image || {};
    var src = fi.url || p.image;
    var alt = fi.alt || p.title;
    var sold = p.available === false;
    return '<a class="sas-card sas-opt' + (sold ? ' is-soldout' : '') + '" href="' + esc(p.url) + '">' +
      '<span class="sas-card-img">' +
        (src ? '<img src="' + esc(imgUrl(src, 300)) + '" srcset="' + esc(imgUrl(src, 200)) + ' 200w, ' + esc(imgUrl(src, 300)) + ' 300w, ' + esc(imgUrl(src, 450)) + ' 450w" sizes="(min-width: 750px) 220px, 88px" alt="' + esc(alt) + '" loading="lazy" width="300" height="300">' : '') +
        (off > 0 ? '<span class="sas-off">' + off + '% off</span>' : '') +
      '</span>' +
      '<span class="sas-card-body">' +
        (p.type ? '<span class="sas-eyebrow">' + esc(p.type) + '</span>' : '') +
        '<span class="sas-card-t">' + hl(p.title, query) + '</span>' +
        '<span class="sas-price"><b>' + money(price) + '</b>' + (off > 0 ? '<s>' + money(cmp) + '</s>' : '') + '</span>' +
        (sold ? '<span class="sas-stock">Currently unavailable</span>' : '') +
      '</span></a>';
  }

  function skeleton() {
    var card = '<div class="sas-card sas-card--sk"><span class="sas-card-img"><span class="sas-sk"></span></span><span class="sas-card-body"><span class="sas-sk" style="height:12px;width:45%"></span><span class="sas-sk" style="height:14px;margin-top:6px"></span><span class="sas-sk" style="height:14px;width:60%;margin-top:6px"></span></span></div>';
    $('[data-sas-products]').innerHTML = card + card + card + card;
    $('[data-sas-sugg]').innerHTML = '<li><span class="sas-sk sas-sk-line" style="width:80%"></span></li><li><span class="sas-sk sas-sk-line" style="width:65%"></span></li><li><span class="sas-sk sas-sk-line" style="width:72%"></span></li>';
    $('[data-sas-sugg-wrap]').hidden = false;
    $('[data-sas-cols-wrap]').hidden = true;
    $$('[data-sas-q]').forEach(function (s) { s.textContent = q(); });
  }

  function render(query, res) {
    S.root.classList.remove('is-loading');
    var products = res.products || [];
    var queries = (res.queries || []).slice(0, 6);
    var cols = (res.collections || []).slice(0, 4);
    $$('[data-sas-q]').forEach(function (s) { s.textContent = query; });
    $$('[data-sas-all]').forEach(function (a) { a.href = searchUrl(query); });

    if (!products.length && !queries.length && !cols.length) {
      showView('empty');
      var waBtn = $('[data-sas-view="empty"] [data-sas-wa]');
      if (waBtn && S.wa) waBtn.href = 'https://wa.me/' + S.wa + '?text=' + encodeURIComponent('Hi Sona Arts, I am looking for: ' + query);
      live('No results for ' + query);
      return;
    }
    showView('live');

    var lq = query.toLowerCase();
    if (!queries.some(function (it) { return String(it.text).toLowerCase() === lq; })) {
      queries.unshift({ text: query });
      queries = queries.slice(0, 6);
    }
    $('[data-sas-sugg-wrap]').hidden = !queries.length;
    $('[data-sas-sugg]').innerHTML = queries.map(function (it) {
      return '<li><a class="sas-sugg-a sas-opt" role="option" href="' + esc(searchUrl(it.text)) + '" data-go-term="' + esc(it.text) + '">' + ICON.search +
        '<span class="sas-sugg-t">' + suggHtml(it.text, query) + '</span></a>' +
        '<button type="button" class="sas-fill" data-fill="' + esc(it.text) + '" aria-label="Search for ' + esc(it.text) + '" tabindex="-1">' + ICON.fill + '</button></li>';
    }).join('');

    $('[data-sas-cols-wrap]').hidden = !cols.length;
    $('[data-sas-cols]').innerHTML = cols.map(function (c) {
      return '<a class="sas-chip sas-opt" href="' + esc(c.url) + '">' + ICON.grid + '<span>' + esc(c.title) + '</span></a>';
    }).join('');

    $('[data-sas-products]').innerHTML = products.length
      ? products.map(function (p) { return cardHtml(p, query); }).join('')
      : '<p class="sas-note">No products match “' + esc(query) + '” yet. Try one of the suggestions.</p>';
    live(products.length + (products.length === 1 ? ' product' : ' products') + ' found for ' + query);
  }

  function fetchQ(query) {
    var key = query.toLowerCase();
    if (S.cache[key]) { render(query, S.cache[key]); return; }
    if (S.ctrl) { try { S.ctrl.abort(); } catch (e) {} }
    S.ctrl = window.AbortController ? new AbortController() : null;
    S.root.classList.add('is-loading');
    var url = S.suggestUrl + '.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection,query&resources[limit]=8&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag,vendor';
    fetch(url, { signal: S.ctrl ? S.ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        var res = (j && j.resources && j.resources.results) || {};
        S.cache[key] = res;
        if (q().toLowerCase() === key) render(query, res);
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        S.root.classList.remove('is-loading');
        if (q().toLowerCase() === key) {
          showView('live');
          $('[data-sas-sugg-wrap]').hidden = true;
          $('[data-sas-products]').innerHTML = '<p class="sas-note">Something went wrong. Press Enter to see all results for “' + esc(query) + '”.</p>';
        }
      });
  }

  function onInput() {
    var v = q();
    var clr = $('.sas-clear');
    if (clr) clr.hidden = !S.input.value;
    clearTimeout(S.timer);
    setActive(-1);
    if (v.length < 2) {
      if (S.ctrl) { try { S.ctrl.abort(); } catch (e) {} }
      S.root.classList.remove('is-loading');
      renderRecent();
      showView('idle');
      return;
    }
    var cached = S.cache[v.toLowerCase()];
    if (!cached && currentView() !== $('[data-sas-view="live"]')) { showView('live'); skeleton(); }
    S.timer = setTimeout(function () { fetchQ(v); }, cached ? 0 : 160);
  }

  function setQ(t) {
    S.input.value = t;
    onInput();
    focusInput();
  }

  /* Navigation (keeps browser history clean when the back button closes search) */
  function nav(url) {
    if (S.pushed && !design) {
      S.pendingNav = url;
      S.pushed = false;
      history.back();
      setTimeout(function () {
        if (S.pendingNav) { var u = S.pendingNav; S.pendingNav = null; location.href = u; }
      }, 400);
    } else {
      location.href = url;
    }
  }
  function track(term) {
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push({ event: 'search', search_term: term }); } catch (e) {}
  }

  /* Open / close */
  function focusInput() {
    try { S.input.focus({ preventScroll: true }); } catch (e) { S.input.focus(); }
    try { var n = S.input.value.length; S.input.setSelectionRange(n, n); } catch (e) {}
  }
  function open() {
    if (!S.root) return;
    if (S.open) { focusInput(); return; }
    S.open = true;
    S.lastFocus = document.activeElement;
    S.root.hidden = false;
    void S.root.offsetWidth;
    S.root.classList.add('is-open');
    document.documentElement.classList.add('sas-lock');
    formatMoney();
    focusInput();
    onInput();
    if (!design) {
      try {
        if (!(history.state && history.state.sas)) {
          history.pushState(Object.assign({}, history.state || {}, { sas: 1 }), '');
          S.pushed = true;
        }
      } catch (e) {}
    }
  }
  function close(fromPop) {
    if (!S.open) return;
    S.open = false;
    clearTimeout(S.timer);
    if (S.ctrl) { try { S.ctrl.abort(); } catch (e) {} }
    S.root.classList.remove('is-open', 'is-loading');
    document.documentElement.classList.remove('sas-lock');
    setTimeout(function () { if (!S.open && S.root) S.root.hidden = true; }, reduce ? 0 : 220);
    if (!fromPop && S.pushed) { S.pushed = false; try { history.back(); } catch (e) {} }
    S.quiet = true;
    var lf = S.lastFocus;
    try {
      if (lf && lf.classList && lf.classList.contains('ws-search-input')) {
        var b = lf.form && lf.form.querySelector('button[type="submit"]');
        if (b) b.focus({ preventScroll: true }); else lf.blur();
      } else if (lf && lf.focus && lf !== document.body) {
        lf.focus({ preventScroll: true });
      } else if (document.activeElement) {
        document.activeElement.blur();
      }
    } catch (e) {}
    setTimeout(function () { S.quiet = false; }, 60);
  }

  function trap(e) {
    var f = $$('a[href], button, input:not([type="hidden"])', $('.sas-panel')).filter(function (el) {
      return !el.disabled && el.tabIndex !== -1 && vis(el);
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function onKey(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      if (S.input.value) { S.input.value = ''; onInput(); focusInput(); } else { close(); }
      return;
    }
    if (e.key === 'Tab') { trap(e); return; }
    if (e.target !== S.input) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var list = opts();
      if (!list.length) return;
      e.preventDefault();
      var i = S.active + (e.key === 'ArrowDown' ? 1 : -1);
      if (i < -1) i = list.length - 1;
      if (i >= list.length) i = -1;
      setActive(i, list);
    } else if (e.key === 'Enter' && S.active >= 0) {
      var l2 = opts();
      if (l2[S.active]) { e.preventDefault(); l2[S.active].click(); }
    }
  }

  function onClick(e) {
    var t = e.target;
    if (t.closest('[data-sas-close]')) { e.preventDefault(); close(); return; }
    if (t.closest('.sas-clear')) { e.preventDefault(); S.input.value = ''; onInput(); focusInput(); return; }
    if (t.closest('[data-sas-clear-recent]')) {
      e.preventDefault();
      try { localStorage.removeItem(RECENT_KEY); } catch (err) {}
      renderRecent();
      focusInput();
      return;
    }
    var fill = t.closest('[data-fill]');
    if (fill) { e.preventDefault(); setQ(fill.getAttribute('data-fill')); return; }
    var a = t.closest('a[href]');
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
    if (/^(tel:|mailto:|https?:\/\/wa\.me)/i.test(a.getAttribute('href') || '')) return;
    var term = a.getAttribute('data-term');
    if (term) { e.preventDefault(); setQ(term); return; }
    var go = a.getAttribute('data-go-term');
    if (go) { addRecent(go); track(go); }
    else if (q().length > 1 && !a.closest('[data-sas-view="idle"]')) { addRecent(q()); track(q()); }
    e.preventDefault();
    nav(a.href);
  }

  function onSubmit(e) {
    e.preventDefault();
    var v = q();
    if (!v) { focusInput(); return; }
    addRecent(v);
    track(v);
    nav(searchUrl(v));
  }

  /* Rotating "Search for …" words */
  function rotate() {
    if (!S.words.length) return;
    S.wordI = (S.wordI + 1) % S.words.length;
    var w = S.words[S.wordI];
    document.querySelectorAll('.ws-search-input').forEach(function (inp) {
      inp.setAttribute('placeholder', 'Search for “' + w + '”');
    });
    var el = S.root && $('[data-sas-word]');
    if (!el) return;
    if (reduce || !S.open) { el.textContent = w; return; }
    el.classList.add('is-out');
    setTimeout(function () {
      el.textContent = w;
      el.classList.remove('is-out');
      el.classList.add('is-in');
      void el.offsetWidth;
      el.classList.remove('is-in');
    }, 220);
  }

  /* Header search box opens this panel */
  function hookHeader() {
    document.querySelectorAll('.ws-search-input').forEach(function (inp) {
      if (inp.__sas) return;
      inp.__sas = 1;
      inp.setAttribute('readonly', '');
      inp.setAttribute('aria-haspopup', 'dialog');
      ['role', 'aria-owns', 'aria-controls', 'aria-autocomplete', 'aria-expanded'].forEach(function (n) { inp.removeAttribute(n); });
      if (S.words.length) inp.setAttribute('placeholder', 'Search for “' + S.words[0] + '”');
      var openFrom = function () {
        if (S.quiet) return;
        if (inp.value && S.input && !S.input.value) S.input.value = inp.value;
        open();
      };
      inp.addEventListener('focus', openFrom);
      inp.addEventListener('click', function (e) { e.preventDefault(); openFrom(); });
    });
    document.querySelectorAll('.ws-search form').forEach(function (f) {
      if (f.__sas) return;
      f.__sas = 1;
      f.addEventListener('submit', function (e) { e.preventDefault(); open(); });
    });
    document.querySelectorAll('[data-sas-open]').forEach(function (b) {
      if (b.__sas) return;
      b.__sas = 1;
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
  }

  function mount() {
    var all = document.querySelectorAll('#sa-search');
    var fresh = null, old = null;
    for (var i = 0; i < all.length; i++) {
      if (all[i].parentElement === document.body) old = all[i]; else fresh = all[i];
    }
    if (!fresh) return;
    var wasOpen = S.open;
    if (wasOpen) { S.open = false; document.documentElement.classList.remove('sas-lock'); }
    if (old && old !== fresh) old.parentNode.removeChild(old);
    document.body.appendChild(fresh);
    S.root = fresh;
    S.input = $('.sas-input');
    S.sectionId = fresh.getAttribute('data-section-id');
    S.searchUrl = fresh.getAttribute('data-search-url') || '/search';
    S.suggestUrl = fresh.getAttribute('data-suggest-url') || '/search/suggest';
    S.wa = fresh.getAttribute('data-wa') || '';
    S.words = (fresh.getAttribute('data-rotate') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    S.wordI = 0;
    if (S.words.length) $('[data-sas-word]').textContent = S.words[0];
    S.cache = {};
    fresh.addEventListener('click', onClick);
    fresh.addEventListener('keydown', onKey);
    S.input.addEventListener('input', onInput);
    $('.sas-bar').addEventListener('submit', onSubmit);
    formatMoney();
    hookHeader();
    if (wasOpen) open();
  }
  window.__sasMount = mount;

  /* One-time global listeners */
  window.addEventListener('popstate', function () {
    if (S.pendingNav) { var u = S.pendingNav; S.pendingNav = null; location.href = u; return; }
    if (S.open) { S.pushed = false; close(true); }
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && S.open) { S.pushed = false; close(true); }
  });
  document.addEventListener('keydown', function (e) {
    if (S.open || e.defaultPrevented) return;
    var tag = (e.target && e.target.tagName) || '';
    var typing = /INPUT|TEXTAREA|SELECT/.test(tag) || (e.target && e.target.isContentEditable);
    if ((e.key === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey) || ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K'))) {
      e.preventDefault();
      open();
    }
  });
  setInterval(rotate, 2600);
  document.addEventListener('DOMContentLoaded', hookHeader);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#sa-search')) mount();
    hookHeader();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.detail && e.detail.sectionId === S.sectionId) open();
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.detail && e.detail.sectionId === S.sectionId) open();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.detail && e.detail.sectionId === S.sectionId) close();
  });

  mount();
})();
